// https://www.typescriptlang.org/docs/handbook/advanced-types.html#exhaustiveness-checking
// eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
export function assertNever( type: never ) { }

export function roundDecimal( value: number, decimals = 0 ) {
  const p = Math.pow( 10, decimals )
  return Math.round( value * p ) / p
}
